export default "__VITE_ASSET__CXM0Nisq__"